import { useTranslation } from 'react-i18next';
import React from 'react';
import FormField from '../../../core/components/FormField.tsx';
import DropArea from '../../../core/components/DropArea.tsx';
import Button from '../../../core/components/Button.tsx';
import { withIcon } from '../../../core/components/Icon.tsx';
import { faTrash, faFile } from '@fortawesome/pro-regular-svg-icons';
import { useToaster } from '../../../core/components/Toast.tsx';
import { KNOWLEDGE_FILE_ACCEPT, KNOWLEDGE_SUPPORTED_EXTENSIONS_LABEL } from '../constants.ts';

const RemoveIcon = withIcon(faTrash);
const FileIcon = withIcon(faFile);

const fileName = (file: File | any): string => (file instanceof File ? file.name : file?.name || '');

const VoiceAgentKnowledgeFormFields = ({ form }) => {
    const { t } = useTranslation('voice_agents');
    const { publishToast } = useToaster();
    const files = form.watch('files') || [];

    const handleFilesChange = (newFiles: File[]) => {
        form.setValue('files', [...(form.getValues('files') || []), ...newFiles]);
    };

    const handleDelete = (fileToDelete: File | any) => {
        form.setValue(
            'files',
            (form.getValues('files') || []).filter((f: File | any) => f !== fileToDelete)
        );
    };

    const handleDropRejected = (fileRejections: any[]) => {
        publishToast({
            description: t('form.unsupportedFileType', {
                files: fileRejections.map((r) => r.file.name).join(', '),
                supportedTypes: KNOWLEDGE_SUPPORTED_EXTENSIONS_LABEL,
            }),
            status: 'error',
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <FormField
                label={t('form.knowledgeFiles')}
                helpText={t('form.knowledgeFilesDescription', { supportedTypes: KNOWLEDGE_SUPPORTED_EXTENSIONS_LABEL })}
            >
                <div className="flex flex-col gap-2">
                    <DropArea
                        placeholder={t('form.dropFilesPlaceholder')}
                        onFilesChange={handleFilesChange}
                        onDropRejected={handleDropRejected}
                        accept={KNOWLEDGE_FILE_ACCEPT}
                        files={[]}
                    />
                    {files.length > 0 && (
                        <div className="flex flex-col gap-2">
                            {files.map((file: File | any, index: number) => (
                                <div
                                    key={index}
                                    className="w-full flex justify-between items-center border border-solid border-line-weak rounded p-3 shadow-sm text-content-strong"
                                >
                                    <div className="flex items-center gap-2 px-1 min-w-0">
                                        <FileIcon className="text-content-medium flex-none" />
                                        <span className="text-sm font-medium truncate">{fileName(file)}</span>
                                    </div>
                                    <Button
                                        variant="ghost"
                                        onClick={() => handleDelete(file)}
                                        className="text-content-danger-strong"
                                        type="button"
                                    >
                                        <RemoveIcon />
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </FormField>
        </div>
    );
};

export default VoiceAgentKnowledgeFormFields;
